import { components } from 'react-select'
import React from 'react'

function CustomSingleValue ({ children, ...props }) {
  const { data } = props

  return (
    <components.SingleValue { ...props }>
      <img style={ { float: 'left' } } src={ data.url } alt={ data.label }
        height="30px"/>
      &nbsp;
      { ' - ' }
      { children }
    </components.SingleValue>
  )
}

function CustomOption (props) {
  const { data } = props
  return (
    <components.Option { ...props }>
      <img src={ data.url } alt={ data.label } height="30px"/>
      { ' - ' }
      { data.label }
    </components.Option>
  )
}

export { CustomSingleValue, CustomOption }
